/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { setTimeShow, setStep, resetSelectedFNOLItems } from '../../../actions/claimSubmitActions';
import { isMobile } from 'react-device-detect';
import { POLICY_DETAILS, CLAIMS, CLAIMS_HISTORY, DASHBOARD } from '../../../routes/routes';
import { Accordion, Card, Image } from 'react-bootstrap';
import { navigateTo } from '../../../actions/navigationActions';
import NeedHelp from '../../../../src/components/BaseTemplate/SSPCustomComponentLibrary/NeedHelp/NeedHelp';
import { showFnolCallMeModal } from '../../../actions/modalActions';

class FnolStep11Sub1 extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
            roadSide0Open: false,
            roadSide1Open: false,
            roadSide2Open: false,
            roadSide3Open: false,
            roadSide4Open: false,
            roadSide5Open: false,
            roadSide6Open: false,
        }
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleCoverRedirect = this.handleCoverRedirect.bind(this);
        this.handleCallMeBack = this.handleCallMeBack.bind(this);
    }

    handleCallMeBack = async (e: any) => {
        this.props.handleCallMeBack();
    }

    handleCoverRedirect() {
        if (isMobile) {
            this.props.redirectTo(POLICY_DETAILS);
        }
    }

    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }

    handleRoadAccordianArrow(e: any) {
        switch (e) {
            case 0:
                this.setState({ roadSide0Open: !this.state.roadSide0Open })
                this.setState({ roadSide1Open: false, roadSide02pen: false, roadSide3Open: false, roadSide4Open: false, roadSide5Open: false, roadSide6Open: false })
                break;
            case 1:
                this.setState({ roadSide1Open: !this.state.roadSide1Open })
                this.setState({ roadSide0Open: false, roadSide02pen: false, roadSide3Open: false, roadSide4Open: false, roadSide5Open: false, roadSide6Open: false })
                break;
            case 2:
                this.setState({ roadSide2Open: !this.state.roadSide2Open })
                this.setState({ roadSide0Open: false, roadSide1Open: false, roadSide3Open: false, roadSide4Open: false, roadSide5Open: false, roadSide6Open: false })
                break;
            case 3:
                this.setState({ roadSide3Open: !this.state.roadSide3Open })
                this.setState({ roadSide0Open: false, roadSide1Open: false, roadSide02pen: false, roadSide4Open: false, roadSide5Open: false, roadSide6Open: false })
                break;
            case 4:
                this.setState({ roadSide4Open: !this.state.roadSide4Open })
                this.setState({ roadSide0Open: false, roadSide1Open: false, roadSide02pen: false, roadSide3Open: false, roadSide5Open: false, roadSide6Open: false })
                break;
            case 5:
                this.setState({ roadSide5Open: !this.state.roadSide5Open })
                this.setState({ roadSide0Open: false, roadSide1Open: false, roadSide02pen: false, roadSide03pen: false, roadSide4Open: false, roadSide6Open: false })
                break;
            case 6:
                this.setState({ roadSide6Open: !this.state.roadSide6Open })
                this.setState({ roadSide0Open: false, roadSide1Open: false, roadSide02pen: false, roadSide3Open: false, roadSide4Open: false, roadSide5Open: false })
                break;
            default:
        }
    }

    componentDidMount() {
        this.props.dispatchResetSelectedFNOLItems();
    }

    public render() {
        const isMobile = window.innerWidth <= 975;
        const { profile } = this.props;
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: CLAIMS, description: "Claims" }]
        if (!isMobile) {
            return (
                <div className={"col" + (isMobile ? " px-0 " : "")}>
                    {!isMobile &&
                        <div className="submit-a-claim-history-block mb-5">
                            <div className="container pt-3">
                                <div className="col-12  px-lg-3 mb-4">
                                    <div className="RoadAssist Assist p-3">
                                        <h3 id="help">Don't forget to</h3>
                                        <div className="row align-items-center">
                                            <div className="dont-forget-icons"><img src="./images/Claims/dont-forget-1.png" /></div>
                                            <div className="col align-self-center">Report the incident to the <strong>police</strong> within 24 hours and <strong>get a police case number.</strong> </div>
                                        </div>
                                        <div className="row align-items-center pt-4">
                                            <div className="dont-forget-icons"><img src="./images/Claims/dont-forget-2.png" /></div>
                                            <div className="col align-self-center">
                                                Get the <strong>details of any other party involved.</strong> <br />
                                                <span className="subtext">This applies if anyone else's property was damaged as a result of this incident.</span>
                                            </div>
                                        </div>
                                        <div className="row pt-4 align-items-center">
                                            <div className="dont-forget-icons"><img src="./images/Claims/dont-forget-3.png" /></div>
                                            <div className="col align-self-center">Get details of anyone that <strong>witnessed the incident</strong> (if any).</div>
                                        </div>
                                        <div className="row pt-4 align-items-center">
                                            <div className="dont-forget-icons"><img src="./images/Claims/dont-forget-4.png" /></div>
                                            <div className="col align-self-center"><strong>Get details of all passengers,</strong> if any were present. </div>
                                        </div>
                                        <div className="row pt-4 pb-5 align-items-center">
                                            <div className="dont-forget-icons"><img src="./images/Claims/dont-forget-5.png" /></div>
                                            <div className="col align-self-center">Take pictures of the <strong>incident scene,</strong> the <strong>other car involved</strong> in the incident, and the <strong>other driver's details.</strong></div>
                                        </div>
                                        <button className="btn btn-outline-red mr-2 mb-4" id="progress-button" onClick={() => this.handleRedirect(CLAIMS_HISTORY)}>View claim progress</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className='submit-a-claim-history-block mb-5'>
                        <div className="container pt-3 pb-4">
                            <div className={!isMobile ? 'col-12  px-lg-3' : ''}>
                                <div className={"RoadAssist Assist" + (!isMobile ? ' p-3' : '')}>
                                    <h3 id="FAQ-h3">FAQs</h3>
                                    <div className="mb-4">
                                        <Accordion>
                                            <Card className="mb-2">
                                                <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => this.handleRoadAccordianArrow(0)}>
                                                    <div className="row align-items-center">
                                                        <div className="col pr-0">
                                                            What if I didn't get the other driver�s details?
                                                                    </div>
                                                        <div className="arrow-icons pr-0 align-self-center">
                                                            <Image className={(this.state.roadSide0Open ? ' isRotated' : '')} src="./Images/Claims/Dropdown-arrow-white-24px.png"></Image>
                                                        </div>
                                                    </div>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="0">
                                                    <Card.Body>
                                                        <div className="text">
                                                            <p>Unfortunately, if you weren�t at fault, we won�t be able to assist you with the recovery of any costs. To get the other driver�s info, you can try checking with the police, tow truck operator, or the witnesses.</p>
                                                        </div>
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                            <Card className="mb-2">
                                                <Accordion.Toggle as={Card.Header} eventKey="1" onClick={() => this.handleRoadAccordianArrow(1)}>
                                                    <div className="row align-items-center">
                                                        <div className="col pr-0">
                                                            Who pays for the trauma counselling?
                                                                    </div>
                                                        <div className="arrow-icons pr-0 align-self-center">
                                                            <Image className={(this.state.roadSide1Open ? ' isRotated' : '')} src="./Images/Claims/Dropdown-arrow-white-24px.png"></Image>
                                                        </div>
                                                    </div>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="1">
                                                    <Card.Body>
                                                        <div className="text">
                                                            <p>King Price covers this cost. The counselling is done telephonically and there�s no limit on the number of sessions you can attend. However, if it�s determined that you need more in-depth, face-to-face sessions, Europ Assistance will refer you for further counselling, which will then be for your own account.</p>
                                                        </div>
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                            <Card className="mb-2">
                                                <Accordion.Toggle as={Card.Header} eventKey="2" onClick={() => this.handleRoadAccordianArrow(2)}>
                                                    <div className="row align-items-center">
                                                        <div className="col pr-0">
                                                            How does the trauma counselling work?
                                                                    </div>
                                                        <div className="arrow-icons pr-0 align-self-center">
                                                            <Image className={(this.state.roadSide2Open ? ' isRotated' : '')} src="./Images/Claims/Dropdown-arrow-white-24px.png"></Image>
                                                        </div>
                                                    </div>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="2">
                                                    <Card.Body>
                                                        <div className="text">
                                                            <ul>
                                                                <li>We send a request to Europ Assistance.</li>
                                                                <li>They then contact you, and provide the appropriate counselling.</li>
                                                                <li>During this call, the counsellor determines whether a follow-up call/counselling session is needed, or a face-to-face session (in this case they�ll refer you to a psychologist, which will be for your own account).</li>
                                                            </ul>
                                                        </div>
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                            <Card className="mb-2">
                                                <Accordion.Toggle as={Card.Header} eventKey="3" onClick={() => this.handleRoadAccordianArrow(3)}>
                                                    <div className="row align-items-center">
                                                        <div className="col pr-0">
                                                            What is tow truck assistance and how does it work?
                                                                    </div>
                                                        <div className="arrow-icons pr-0 align-self-center">
                                                            <Image className={(this.state.roadSide3Open ? ' isRotated' : '')} src="./Images/Claims/Dropdown-arrow-white-24px.png"></Image>
                                                        </div>
                                                    </div>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="3">
                                                    <Card.Body>
                                                        <div className="text">
                                                            <p>Here in our kingdom, we call this �accident assist�. This service is offered when a comprehensively insured car is involved in an accident and not drivable afterwards.
                                                                           <br /><br />
                                                                           You/the incident driver, must then call our emergency assist line so that we can arrange for your car to be towed to the closest assessment facility by 1 of our approved towing operators. The towing operator will also assist the driver and passenger/s with transport back home, or to their place of work.
                                                                         </p>
                                                        </div>
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                            <Card className="mb-2">
                                                <Accordion.Toggle as={Card.Header} eventKey="4" onClick={() => this.handleRoadAccordianArrow(4)}>
                                                    <div className="row align-items-center">
                                                        <div className="col pr-0">
                                                            Which tow truck operator does King Price use?
                                                                    </div>
                                                        <div className="arrow-icons pr-0 align-self-center">
                                                            <Image className={(this.state.roadSide4Open ? ' isRotated' : '')} src="./Images/Claims/Dropdown-arrow-white-24px.png"></Image>
                                                        </div>
                                                    </div>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="4">
                                                    <Card.Body>
                                                        <div className="text">
                                                            <p>We have agreements in place with a panel of towing operators. To ensure that you�re assisted as quickly as possible, we appoint the towing operator closest to the scene of the accident. We also send you an SMS with the details of the towing operator, the driver, and the tow truck so that you know who to look out for.</p>
                                                        </div>
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                            {isMobile &&
                                                <>
                                                    <Card className="mb-2">
                                                        <Accordion.Toggle as={Card.Header} eventKey="5" onClick={() => this.handleRoadAccordianArrow(5)}>
                                                            <div className="row align-items-center">
                                                                <div className="col pr-0">
                                                                    Do you need my details to call for medical assistance?
                                                                    </div>
                                                                <div className="arrow-icons pr-0 align-self-center">
                                                                    <Image className={(this.state.roadSide5Open ? ' isRotated' : '')} src="./Images/Claims/Dropdown-arrow-white-24px.png"></Image>
                                                                </div>
                                                            </div>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey="5">
                                                            <Card.Body>
                                                                <div className="text">
                                                                    <p>
                                                                        No, but please keep your policy or ID number on-hand if possible? We�ll contact Emer-G-Med and they�ll get in touch to assist you.
                                                                        <br /><br />
                                                                        We�ll also cover the cost to transport the injured person/s to the nearest hospital, as well as costs for treatment on the scene. If the treating doctors or medical assistance directors recommend that you be transferred to a different hospital, then we�ll cover that too.
                                                                    </p>
                                                                </div>
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                    <Card className="mb-2">
                                                        <Accordion.Toggle as={Card.Header} eventKey="6" onClick={() => this.handleRoadAccordianArrow(6)}>
                                                            <div className="row align-items-center">
                                                                <div className="col pr-0">
                                                                    If someone�s in the car with me, do they also have access to the king�s medical assist benefit?
                                                                    </div>
                                                                <div className="arrow-icons pr-0 align-self-center">
                                                                    <Image className={(this.state.roadSide6Open ? ' isRotated' : '')} src="./Images/Claims/Dropdown-arrow-white-24px.png"></Image>
                                                                </div>
                                                            </div>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey="6">
                                                            <Card.Body>
                                                                <div className="text">
                                                                    <p>
                                                                        Yes, any person who needs medical attention will be assisted and transported to the nearest hospital if necessary.
                                                                     </p>
                                                                </div>
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                </>
                                            }
                                        </Accordion>
                                    </div>
                                    <div>
                                        <NeedHelp
                                            isClaims={false}
                                            countryId={this.props.profile.countryId}
                                            claimsEmail={this.props.ssp.claims_email}
                                            contactUsTel={this.props.ssp.contactUs_tel}
                                            handleCallMeBack={(e) => this.handleCallMeBack(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        else {
            return (
                <div>
                    <div className={"col-lg-4 col-12" + (isMobile ? " px-0 " : "")}>
                        <div className="meantime-block pb-3 mb-4">
                            <div className="px-lg-3 RoadAssist Assist px-3">
                                <h3 className="Claims-title pt-2">In the meantime</h3>
                                <p className="pColor mb-lg-1">Do you need assistance</p>
                                <hr />
                                <div className="tow-block pb-3 mb-4" onClick={this.props.handleTowAssistModal}>
                                    <div className="row align-items-center">
                                        <div className="dont-forget-icons align-self-center">
                                            <img src="./images/Claims/tow-truck-red.png" />
                                        </div>
                                        <div className="col align-self-center">
                                            Tow truck assistance
                                                    </div>
                                        <div className="text-right align-self-center arrow-icons">
                                            <img src="./images/Claims/Dropdown-arrow-right-white.png" />
                                        </div>
                                    </div>
                                </div>
                                {isMobile &&
                                    <>
                                        <div className="medical-block pb-3 mb-4">
                                            <a href="tel: 0860505050" target="_blank">
                                                <div className="row align-items-center">
                                                    <div className="dont-forget-icons align-self-center">
                                                        <img src="./images/FNOL/ambulance.png" />
                                                    </div>
                                                    <div className="col align-self-center">
                                                        Medical assistance
                                                        </div>
                                                    <div className="arrrow-icons text-right align-self-center">
                                                        <img src="./images/Claims/Dropdown-arrow-right-white.png" />
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </>
                                }
                               <div className={isMobile? "trauma-block mb-4" : "trauma-block" } onClick={this.props.handleTraumaAssistModal}>
                                            <div className="row align-items-center">
                                                <div className="dont-forget-icons align-self-center">
                                                    <img src="./images/Claims/heart-white.png" />
                                                </div>
                                                <div className="col align-self-center">
                                                    Trauma counselling
                                            </div>
                                                <div className="arrow-icons text-right align-self-center">
                                                    <img src="./images/Claims/Dropdown-arrow-right-white.png" />
                                                </div>
                                            </div>
                                        </div>
                                {isMobile &&
                                    <>
                                        <div className="pt-2">
                                            <h3 id="help">Don't forget to</h3>
                                        </div>
                                        <div className="row align-items-center pt-4">
                                            <div className="dont-forget-icons"><img src="./images/Claims/dont-forget-1.png" /></div>
                                            <div className="col align-self-center">Report the incident to the <strong>police</strong> within 24 hours and <strong>get a police case number.</strong> </div>
                                        </div>
                                        <div className="row align-items-center pt-4">
                                            <div className="dont-forget-icons"><img src="./images/Claims/dont-forget-2.png" /></div>
                                            <div className="col align-self-center">
                                                Get the <strong>details of any other party involved.</strong> <br />
                                                <span className="subtext">This applies if anyone else's property was damaged as a result of this incident.</span>
                                            </div>
                                        </div>
                                        <div className="row pt-4 align-items-center">
                                            <div className="dont-forget-icons"><img src="./images/Claims/dont-forget-3.png" /></div>
                                            <div className="col align-self-center">Get details of anyone that <strong>witnessed the incident</strong> (if any).</div>
                                        </div>
                                        <div className="row pt-4 align-items-center">
                                            <div className="dont-forget-icons"><img src="./images/Claims/dont-forget-4.png" /></div>
                                            <div className="col align-self-center"><strong>Get details of all passengers,</strong> if any were present. </div>
                                        </div>
                                        <div className="row pt-4 pb-5 align-items-center">
                                            <div className="dont-forget-icons"><img src="./images/Claims/dont-forget-5.png" /></div>
                                            <div className="col align-self-center">Take pictures of the <strong>incident scene,</strong> the <strong>other car involved</strong> in the incident, and the <strong>other driver's details.</strong></div>
                                        </div>
                                        <button className="btn btn-outline-red mr-2 w-100" onClick={() => this.handleRedirect(CLAIMS_HISTORY)}>View claim progress</button>

                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>

            )
        }

    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        claimSubmit: state.claimSubmit,
        ssp: state.ssp
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetTimeShow: () => dispatch(setTimeShow()),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchResetSelectedFNOLItems: () => dispatch(resetSelectedFNOLItems()),
        handleCallMeBack: () => dispatch(showFnolCallMeModal()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FnolStep11Sub1)